"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MailListItemContextMenu_1 = require("owa-mail-list-context-menu/lib/components/MailListItemContextMenu");
exports.MailListItemContextMenu = MailListItemContextMenu_1.default;
//# sourceMappingURL=lazyIndex.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/owa-mail-list-context-menu/lib/lazyIndex.js
// module id = 2581
// module chunks = 81